import React, { Component } from 'react';
import Page from '../../components/Page';
import { Link, Redirect } from 'react-router-dom';
import { post, getFull } from '../../util/api';
import { Segment, Table, Breadcrumb, Icon, Label, Button, Dropdown, Modal, Input } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
class Folder extends Component {
	state = {
		loading: true,
	};
	componentDidMount() {
		this.getProductionData();
	}
	async getProductionData() {
		let { shop } = this.props;
		await getFull(shop.server_config.production_images).then((data) => {
			console.log(data.result);
			this.setState({ data: data.result.folders, loading: false, tableloading: false, folder_data: data.result.name });
		});
	}
	sumFilter(data, status) {
		return _.sumBy(_.flatten(_.map(data, (o) => _.filter(o.kolaj, (it) => it && it.status === status))), 'count');
	}
	build() {
		this.setState({ buildLoading: true });
		let { folder } = this.props.match.params;
		post('/shop/build', { folder_id: folder }).then(() => this.setState({ buildLoading: false }));
	}
	async stateUpdate(subfolder_id, state_now) {
		let state = state_now === 'active' ? 'passive' : 'active';
		this.setState({ tableloading: true });
		await post('/shop/state/update', { subfolder_id: parseInt(subfolder_id), state }).then(() => this.getData());
	}
	async updateSubFolder() {
		this.setState({ btnLoadName: true });
		let { selected_sub, showing_name } = this.state;

		let body = {
			...selected_sub.data,
			showing_name,
		};
		await post(`/shop/subfolder/update/${selected_sub.id}`, { data: body }).then(() => {
			this.setState({ openNameModal: false, btnLoadName: false });
			this.getData();
		});
	}
	render() {
		const { t, subdomain } = this.props;
		let { loading, data, folder_data, tableloading, openNameModal, showing_name, btnLoadName, selected_sub, buildLoading } = this.state;
		let { folder } = this.props.match.params;
		if (loading)
			return (
				<Page
					header={
						<Breadcrumb size="big">
							<Breadcrumb.Section as={Link} to={`/wgroup`}>
								<Icon name="feed" />
								Broadcast
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon={{ name: 'asterisk', loading: true }} />
						</Breadcrumb>
					}
				>
					<Page.Loader></Page.Loader>
				</Page>
			);
		/* if (!data.length) {
			return <Redirect to="/wgroup" />;
		} */
		let verified_total = data && _.sumBy(data.files, 'images.length');
		return (
			<Page
				header={
					<Breadcrumb size="big">
						<Breadcrumb.Section as={Link} to={`/wgroup`}>
							<Icon name="feed" />
							Broadcast
						</Breadcrumb.Section>
						<Breadcrumb.Divider icon="right chevron" />

						<Breadcrumb.Section>{folder_data}</Breadcrumb.Section>
					</Breadcrumb>
				}
			>
				{tableloading ? (
					<Page.Loader></Page.Loader>
				) : (
					<Page.Wrap>
						<Segment>
							<div style={{ display: 'flex' }}>
								<div style={{ marginLeft: 'auto' }}>
									{verified_total ? (
										<Label color="green" image>
											Onaylanan
											<Label.Detail>{verified_total}</Label.Detail>
										</Label>
									) : null}
								</div>
							</div>
							<Table>
								<Table.Header>
									<Table.Row>
										<Table.HeaderCell width={4}>{t('name')}</Table.HeaderCell>
										<Table.HeaderCell width={2}>{t('date')}</Table.HeaderCell>
										<Table.HeaderCell width={2}>{t('status')}</Table.HeaderCell>
										<Table.HeaderCell width={8}>{t('details')}</Table.HeaderCell>
									</Table.Row>
								</Table.Header>
								<Table.Body>
									{_.map(data.files, (it) => {
										return (
											<Table.Row key={it.name}>
												<Table.Cell>
													<Link to={'/wgroup/send_production/' + it.name}>
														{it.name} {it.showing_name ? ' (' + it.showing_name + ')' : null}
													</Link>
												</Table.Cell>

												<Table.Cell>{moment(it.mtime).format('DD-MM-YYYY HH:mm')}</Table.Cell>
												<Table.Cell>
													{<Icon name={'check'} color={'green'}></Icon>}
													{t('active')}
												</Table.Cell>
												<Table.Cell style={{ textAlign: 'right' }}>
													<Label color="green" image>
														Toplam Resim
														<Label.Detail>{it.images.length}</Label.Detail>
													</Label>
												</Table.Cell>
											</Table.Row>
										);
									})}
								</Table.Body>
							</Table>
						</Segment>
					</Page.Wrap>
				)}
			</Page>
		);
	}
}

export default connect((state) => ({ shop: state.product.shop }))(withTranslation()(Folder));
